<template>
  <component :is="layout">
    <router-view/>
  </component>
</template>


<script>
import { mapGetters } from 'vuex';
import DefaultLayout from "./layouts/DefaultLayout";
import EmptyLayout from "./layouts/EmptyLayout";
import {RefreshClientOnUpdateMixin} from "@/mixins/RefreshClientOnUpdateMixin";
import VueYandexMetrika from 'vue-yandex-metrika'
import Vue from 'vue'
import settingsConfig from '@/../clientConfig/settings'

const DESIGN_V2_COLOR_VARS = {
  primary: '--kn-primary',
  primary_hover: '--kn-primary-hover',
  primary_soft: '--kn-primary-soft',
  primary_softer: '--kn-primary-softer',
  primary_ring: '--kn-primary-ring',
  on_primary: '--kn-on-primary',
}

export default {
  name:"app",
  mixins: [RefreshClientOnUpdateMixin],
  components: {DefaultLayout, EmptyLayout},
  computed: {
    ...mapGetters([ 'user' ]),
    ...mapGetters('settings', {
      settings: 'settings',
      useNewDesign: 'useNewDesign',
      useDesignV2: 'useDesignV2',
      theme: 'theme',
    }),
    layout() {
      return this.$route.meta.layout || 'default-layout'
    }
  },
  watch: {
    settings(){
      if( this.settings.yandex_metrika_id ){
        this.addYandexMetrika();
      }
    },
    theme: {
      immediate: true,
      handler(theme) {
        if( this.useDesignV2 ){
          document.documentElement.setAttribute('data-theme', theme);
          this.applyDesignV2Colors(theme);
        }
      }
    },
  },

  mounted() {
    if( this.useNewDesign ){
      document.body.classList.add("newDesign");
    }
    if( this.useDesignV2 ){
      document.body.classList.add("designV2");
    }
    this.initAppVersionCheck();
  },

  methods: {
    applyDesignV2Colors(theme) {
      const palettes = settingsConfig.design_v2_theme;
      if( !palettes ){
        return;
      }
      const palette = palettes[theme] || palettes.light || {};
      const root = document.documentElement;
      Object.keys(DESIGN_V2_COLOR_VARS).forEach(key => {
        if( palette[key] ){
          root.style.setProperty(DESIGN_V2_COLOR_VARS[key], palette[key]);
        }
      });
    },
    addYandexMetrika() {
      let options = {clickmap:true, trackLinks:true, accurateTrackBounce:true};
      if( this.settings.yandex_metrika_options ){
        try {
          options = JSON.parse(this.settings.yandex_metrika_options);
        } catch (e) {
          console.error('Yandex Metrika Options is not valid JSON');
        }
      }
      new VueYandexMetrika(Vue,{
        id: this.settings.yandex_metrika_id,
        router: this.$router,
        env: 'production',
        debug: false,
        options: options,
      });
    },
  }

}
</script>

<style lang="scss">
//@import url("../node_modules/@fortawesome/fontawesome-free/css/all.css");
@import "../node_modules/@fortawesome/fontawesome-free/css/all.css";
@import "assets/css/fonts.css";
@import "assets/css/style.scss";
@import "assets/css/common.scss";
@import "@/assets/css/newDesign.scss";
@import "@/assets/css/designV2/index.scss";
</style>
